import { config } from '../../../config';
import { consentManager } from '../../privacy';
import { getActorObject } from '../pulseActor';

import { syncPageViewId, exposePulseInstanceAsGlobal } from './helpers';
import { createExperimentsBuilder } from './builders';

import type { EventInput, Tracker } from '@spt-tracking/pulse-sdk';

let trackerPromise: Promise<Tracker>;

const initTrackerInstance = () => {
  return new Promise<Tracker>((resolve) => {
    if (!config.enableTracking) {
      return;
    }

    const pulse = window.pulse!;
    pulse(
      'init',
      config.pulse.site,
      {
        useBeaconWhenAvailable: true,
        consents: consentManager.getConsentsForPulse(),
        requireAdvertisingOptIn: consentManager.type !== 'fallback',
      },
      undefined,
      'svip-tracker'
    );
    pulse('svip-tracker', (tracker) => resolve(tracker));
  });
};

const initTracker = async () => {
  const tracker = await initTrackerInstance();

  syncPageViewId(tracker);
  consentManager.subscribeTrackerToConsents(tracker);
  exposePulseInstanceAsGlobal(tracker);

  tracker.update({
    actor: getActorObject(config.provider, config.pulse.actorRealm),
    experiments: createExperimentsBuilder(),
  });

  return tracker;
};

export const getTracker = () => {
  if (trackerPromise) {
    return trackerPromise;
  }

  trackerPromise = initTracker();

  return trackerPromise;
};

export const pulseTrackPageView = async (event: EventInput) => {
  try {
    const tracker = await getTracker();

    await tracker.trackPageView(event);
  } catch (err) {
    console.error(err);
  }
};

export const pulseTrackEvent = async (
  eventType: 'engagementEvent' | 'trackerEvent',
  event: EventInput
) => {
  try {
    const tracker = await getTracker();

    await tracker.track(eventType, event);
  } catch (err) {
    console.error(err);
  }
};
